import Grid from "@mui/material/Grid";
import React from "react";
import styled from "styled-components";
import colors from "../../../assets/styles/colors";
import {t} from "i18next";
import Unknown from "../../../assets/images/unknown.svg";

const Avatar = styled.img`
    border-radius: 100rem;
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    object-position: center center;
    
    @media (max-width: 599px) {
        width: 50%;
    }
`

const DetailsWrapper = styled.section`
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    gap: 2px;
`

const DisplayName = styled.h4`
    color: ${colors.semiPrimaryTextColor};
    font-weight: 600;
    line-height: 1;
    @media (max-width: 599px) {
        width: 100%;
        text-align: center;
    }
`

const ProfilePictureWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    @media (max-width: 599px) {
        justify-content: center;
    }
`

const BioContent = styled.p`
    color: ${colors.semiPrimaryTextColor};
    font-weight: 500;
    line-height: 1.7;
    @media (max-width: 599px) {
        line-height: 1.6;
        margin: 0;
        width: 100%;
        text-align: center;
    }
`

const ProfileActionButton = styled.button`
    padding: 8px 30px;
    background-color: ${colors.primaryColor};
    color: #fff;
    text-transform: capitalize;
    font-weight: 500;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    transition: 0.3s;
    outline: none;
    border: none;

    @media (max-width: 599px) {
        flex: unset;
        padding: 10px 10px;
        width: 100%;
    }

    &:hover {
        opacity: 0.6;
    }
`

const ButtonsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    @media (max-width: 599px) {
        flex-direction: column;
        width: 100%;
        gap: 8px;
        margin-top: 2rem;
    }
`

const ForeignProfileHeader = ({avatar, displayName, bio, onDonateClick, onVolunteeringClick}) => {
    return (
        <Grid container spacing={2}
              sx={{paddingLeft: "1rem", paddingRight: "1rem", display: "flex", justifyContent: "center"}}>
            <Grid item xs={12} sm={3} lg={2}>
                <ProfilePictureWrapper>
                    <Avatar src={avatar || Unknown} alt="Avatar"/>
                </ProfilePictureWrapper>
            </Grid>
            <Grid item xs={12} sm={9} lg={10}>
                <DetailsWrapper>
                    <DisplayName>{displayName}</DisplayName>
                    <BioContent>{bio}</BioContent>
                    <ButtonsWrapper>
                        <ProfileActionButton onClick={onDonateClick}>
                            {t('donate_button')}
                        </ProfileActionButton>
                        <ProfileActionButton onClick={onVolunteeringClick}>
                            {t('become_volunteer_button')}
                        </ProfileActionButton>
                    </ButtonsWrapper>
                </DetailsWrapper>
            </Grid>
        </Grid>
    );
}

export default ForeignProfileHeader